import { forwardRef, SVGProps } from 'react';

export const ShieldIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  function ShieldIcon(props, ref) {
    return (
      <svg
        ref={ref}
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M7.5 1.2 12.6 3.1v3.7c0 3.2-2.2 5.5-5.1 6.6-2.9-1.1-5.1-3.4-5.1-6.6V3.1L7.5 1.2Z"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
